import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import MainSprav from "./pages/MainSprav";
import Sprav from "./pages/Sprav";
import HotelSprav from "./pages/HotelSprav";
import UrlPage from "./pages/UrlPage";
import InfoDialog from "./components/landing/InfoDialog";
import MainFooter from "./components/MainFooter";

import "./styles/main.scss";
import "./styles/ui.scss";

// Компонент для отслеживания маршрутов
function TrackPageViews() {
  const location = useLocation();

  useEffect(() => {
    // Отправка pageview при изменении маршрута
    if (window.ym) {
      window.ym(111961544, "hit", location.pathname + location.search);
    }
  }, [location]);

  return null; // Компонент ничего не рендерит
}

function App() {
  // устранение горизонтального смещения на айфонах
  useEffect(() => {
    const preventSwipe = (e) => {
      if (
        Math.abs(e.touches[0].clientX - startX) >
        Math.abs(e.touches[0].clientY - startY)
      ) {
        e.preventDefault();
      }
    };

    let startX = 0;
    let startY = 0;

    const handleTouchStart = (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      if (
        Math.abs(e.touches[0].clientX - startX) >
        Math.abs(e.touches[0].clientY - startY)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("touchstart", handleTouchStart, {
      passive: true,
    });
    document.addEventListener("touchmove", handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);

  return (
    <Router>
      <TrackPageViews />
      <Routes>
        <Route path="/" element={<MainSprav />} />
        <Route path="/:country/:region?/:city?/:place?" element={<Sprav />} />
        <Route
          path="/:country/:region/:city/hotels/:hotel_id"
          element={<HotelSprav />}
        />
        <Route path="/pages/offer" element={<UrlPage url="agreement" />} />
        <Route path="/pages/privacy" element={<UrlPage url="privacy" />} />
      </Routes>
      <InfoDialog />
    </Router>
  );
}

export default App;
